export const hmapPathParamRegex = "{hmapPath:[0-9-]*}";
export const hmapPathParamConfig = {
    hmapPath: { value: '', squash: true }
};
export const HMAPRoutes = [
    {
        "url": "/access-portal",
        "name": "appLayout.harriSH.access-portal",
        "type": "frontend",
        "loginRequired": true,
        "abstract": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["hmap_dashboard"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hmap/hmap.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "?gp",
        "name": "appLayout.harriSH.access-portal.settings",
        "type": "frontend",
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hmap/hmap.downgrade.module");
                }
            },
        ]
    },
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/hmap/hmap.downgrade.module");
                }
            },
        ]
    },
];
//# sourceMappingURL=hmap.routes.js.map